import React, {
  forwardRef,
  useEffect,
  useId,
  useImperativeHandle,
  useState,
} from "react";
import { menuInfo } from "@shared/type/CommonType";
import SnEditor from "@shared/components/SnEditor";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { sendIssueSnapshotTelegramByParams } from "../issueTelegram";
import { getTxtBody } from "@shared/utils/IssueUtils";

interface popupProps {
  formData: any;
  modalRef?: any;
  Menuprops: menuInfo;
  txt_body?: string;
}

/**
 * Modify 팝업
 */
const SN_SFA_ISSUE_REG_005_POP_001 = forwardRef(
  (
    { formData, modalRef, Menuprops, txt_body }: popupProps,
    ref: React.Ref<any>
  ) => {
    const { userInfo } = global();
    const uniqueId = useId();

    const initBody = txt_body;
    const [body, setBody] = useState(txt_body);

    useImperativeHandle(ref, () => ({
      onSave,
    }));

    useEffect(() => {
      showDialog("alter", "수정모드입니다.");
    }, []);

    const onSave = async () => {
      const params = {
        id: "sn_sfa_issue_reg_005_01",
        params: { cd_firm: userInfo.cd_firm, no_issue: formData.no_issue },
      };
      const data: any = await fnGetDataSet(params);
      formData = data[0][0];

      const updateData: any = {
        cd_firm: userInfo.cd_firm,
        no_issue: formData.no_issue,
        tm_amd: formData.tm_amd,
        cd_user_amd: userInfo.cd_user,
        nm_user_amd: userInfo.nm_user,
      };

      if (!body || body === "" || body === initBody) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }

      // js 데이터 추가
      const js_txt_body = getTxtBody(body);
      if (js_txt_body) updateData.js_txt_body = js_txt_body;

      const saveData = {
        sfa_issue: {
          update: [updateData],
        },
      };

      try {
        await fnSave("SN_SFA_ISSUE_REP_005_btnNewIssue", saveData);
        await sendMessage(updateData);
        return true;
      } catch (err) {
        return false;
      }
    };

    const sendMessage = async (data: any) => {
      const params = {
        ...formData,
        ...data,
        ...{ cd_firm: userInfo.cd_firm, msg_flag: "reply" },
      };
      // 2026-03-09: const result = callApi("telegram/sendMsg", params);
      await sendIssueSnapshotTelegramByParams(params);
    };

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
          marginTop: 10,
          overflow: "hidden",
        }}
      >
        <div
          className="no-tailwind"
          style={{
            flex: 1,
            minHeight: 0,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            border: "1px solid rgb(186,191,199)",
            borderRadius: 4,
          }}
        >
          {formData?.no_issue && (
            <SnEditor
              uniqueId={uniqueId}
              selectedData={formData.no_issue}
              body={body || ""}
              setBody={setBody}
            />
          )}
        </div>
      </div>
    );
  }
);

export default SN_SFA_ISSUE_REG_005_POP_001;
